import StockError from './error';

export default {
    [StockError.CheckoutValueIsNotAvailable]:
        'Given quantity exceeds quantity available in checkout and it was rounded down to the highest available.',
    [StockError.CheckoutValueExceedEstimatedValue]:
        "Ordered value can't exceed estimated value. It was rounded down to the remaining from estimated.",
    [StockError.ValueIsNotRounded]: 'Your quantity will be automatically rounded up to nearest package size',
    [StockError.StockValueIsNotAvailable]:
        'Given quantity exceeds quantity available in stock and it was rounded down to the highest available.'
};



// WEBPACK FOOTER //
// ./src/domain/orders/validators/translation.ts